import { PageDisplayedTracker, useClickstream } from '@zenbusiness/application-commons-clickstream';
import { useLocation } from 'react-router-dom';

import getPageName from '#client/utils/getPageName';
import getPageSection from '#client/utils/getPageSection';

/**
 * This component ensures that mixpanel receives a view tracking only on
 * view load and does not issue another tracking until the path changes
 *
 * @component
 * @returns {Element}
 */
export default function TrackView() {
  const { pathname } = useLocation();
  const { isAvoInitialized } = useClickstream();

  if (!isAvoInitialized || !pathname || pathname === '/d/callback') {
    return null;
  }

  return (
    <PageDisplayedTracker
      canonicalPath={pathname}
      pageCategory="dashboard"
      pageName={getPageName(pathname)}
      pageSection={getPageSection(pathname)}
    />
  );
}
